import { Button, Typography } from "@mui/material";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { motion } from "framer-motion";

export const ScrollButton = ({ onClick, text, scrollUp = false, delay = 0.5 }) => {
  const Icon = scrollUp ? KeyboardArrowUpIcon : KeyboardArrowDownIcon;
  const style = scrollUp ? { top: 20 } : { bottom: 20 };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { delay: delay } }}
      style={{
        position: "absolute",
        zIndex: 5,
        left: "50%",
        transform: "translateX(-50%)",
        ...style
      }}
    >
      <Button variant="text" onClick={(e) => onClick(e)} sx={{ display: "flex", flexDirection: "column" }}>
        <Typography variant="caption" color="secondary">
          {text}
        </Typography>
        <motion.div
          animate={{ y: [0, 4, 0] }}
          transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Icon color="secondary" />
        </motion.div>
      </Button>
    </motion.div>
  )
}